/* tslint:disable */
/* eslint-disable */
/**
 * TOM PLANNING SERVICE API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CoolingOrderResponseDto } from '../model';
// @ts-ignore
import type { CreateCoolingOrdersCommand } from '../model';
// @ts-ignore
import type { CreateStrippingOrderCommand } from '../model';
// @ts-ignore
import type { CreateStuffingOrderCommand } from '../model';
// @ts-ignore
import type { ProblemDetails } from '../model';
// @ts-ignore
import type { StrippingOrderResponseDto } from '../model';
// @ts-ignore
import type { StuffingOrderResponseDto } from '../model';
// @ts-ignore
import type { UpdateCargoItemActualAmountCommand } from '../model';
// @ts-ignore
import type { UpdateCoolingOrderCommand } from '../model';
// @ts-ignore
import type { UpdateStrippingOrderCargoItemActualAmountCommand } from '../model';
// @ts-ignore
import type { UpdateStrippingOrderCommand } from '../model';
// @ts-ignore
import type { UpdateStuffingOrderCommand } from '../model';
/**
 * ServiceOrdersApi - axios parameter creator
 */
export const ServiceOrdersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateCoolingOrdersCommand} [createCoolingOrdersCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCoolingOrders: async (createCoolingOrdersCommand?: CreateCoolingOrdersCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/planning/api/ServiceOrders/CreateCoolingOrders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCoolingOrdersCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCoolingOrder: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteCoolingOrder', 'id', id)
            const localVarPath = `/planning/api/ServiceOrders/CoolingOrder/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteStrippingOrder: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteStrippingOrder', 'id', id)
            const localVarPath = `/planning/api/ServiceOrders/StrippingOrder/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteStuffingOrder: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteStuffingOrder', 'id', id)
            const localVarPath = `/planning/api/ServiceOrders/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} ids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByIds: async (ids: Array<number>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('getByIds', 'ids', ids)
            const localVarPath = `/planning/api/ServiceOrders/GetByIds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (ids) {
                localVarQueryParameter['Ids'] = ids;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} ids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCoolingOrdersByIds: async (ids: Array<number>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('getCoolingOrdersByIds', 'ids', ids)
            const localVarPath = `/planning/api/ServiceOrders/GetCoolingOrdersByIds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (ids) {
                localVarQueryParameter['Ids'] = ids;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} ids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStrippingOrdersByIds: async (ids: Array<number>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('getStrippingOrdersByIds', 'ids', ids)
            const localVarPath = `/planning/api/ServiceOrders/GetStrippingOrdersByIds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (ids) {
                localVarQueryParameter['Ids'] = ids;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateStrippingOrderCommand} [createStrippingOrderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        strippingOrder: async (createStrippingOrderCommand?: CreateStrippingOrderCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/planning/api/ServiceOrders/StrippingOrder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createStrippingOrderCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateStuffingOrderCommand} [createStuffingOrderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stuffingOrder: async (createStuffingOrderCommand?: CreateStuffingOrderCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/planning/api/ServiceOrders/StuffingOrder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createStuffingOrderCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateCargoItemActualAmountCommand} [updateCargoItemActualAmountCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCargoItemActualAmount: async (updateCargoItemActualAmountCommand?: UpdateCargoItemActualAmountCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/planning/api/ServiceOrders/UpdateCargoItemActualAmount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCargoItemActualAmountCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateCoolingOrderCommand} [updateCoolingOrderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCoolingOrder: async (updateCoolingOrderCommand?: UpdateCoolingOrderCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/planning/api/ServiceOrders/UpdateCoolingOrder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCoolingOrderCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateStrippingOrderCommand} [updateStrippingOrderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStrippingOrder: async (updateStrippingOrderCommand?: UpdateStrippingOrderCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/planning/api/ServiceOrders/UpdateStrippingOrder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateStrippingOrderCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateStrippingOrderCargoItemActualAmountCommand} [updateStrippingOrderCargoItemActualAmountCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStrippingOrderCargoItemActualAmount: async (updateStrippingOrderCargoItemActualAmountCommand?: UpdateStrippingOrderCargoItemActualAmountCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/planning/api/ServiceOrders/UpdateStrippingOrderCargoItemActualAmount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateStrippingOrderCargoItemActualAmountCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateStuffingOrderCommand} [updateStuffingOrderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStuffingOrder: async (updateStuffingOrderCommand?: UpdateStuffingOrderCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/planning/api/ServiceOrders/UpdateStuffingOrder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateStuffingOrderCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ServiceOrdersApi - functional programming interface
 */
export const ServiceOrdersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ServiceOrdersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateCoolingOrdersCommand} [createCoolingOrdersCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCoolingOrders(createCoolingOrdersCommand?: CreateCoolingOrdersCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCoolingOrders(createCoolingOrdersCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceOrdersApi.createCoolingOrders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCoolingOrder(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCoolingOrder(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceOrdersApi.deleteCoolingOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteStrippingOrder(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteStrippingOrder(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceOrdersApi.deleteStrippingOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteStuffingOrder(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteStuffingOrder(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceOrdersApi.deleteStuffingOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<number>} ids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getByIds(ids: Array<number>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StuffingOrderResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getByIds(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceOrdersApi.getByIds']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<number>} ids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCoolingOrdersByIds(ids: Array<number>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CoolingOrderResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCoolingOrdersByIds(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceOrdersApi.getCoolingOrdersByIds']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<number>} ids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStrippingOrdersByIds(ids: Array<number>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StrippingOrderResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStrippingOrdersByIds(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceOrdersApi.getStrippingOrdersByIds']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateStrippingOrderCommand} [createStrippingOrderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async strippingOrder(createStrippingOrderCommand?: CreateStrippingOrderCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.strippingOrder(createStrippingOrderCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceOrdersApi.strippingOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateStuffingOrderCommand} [createStuffingOrderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stuffingOrder(createStuffingOrderCommand?: CreateStuffingOrderCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stuffingOrder(createStuffingOrderCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceOrdersApi.stuffingOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpdateCargoItemActualAmountCommand} [updateCargoItemActualAmountCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCargoItemActualAmount(updateCargoItemActualAmountCommand?: UpdateCargoItemActualAmountCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCargoItemActualAmount(updateCargoItemActualAmountCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceOrdersApi.updateCargoItemActualAmount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpdateCoolingOrderCommand} [updateCoolingOrderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCoolingOrder(updateCoolingOrderCommand?: UpdateCoolingOrderCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCoolingOrder(updateCoolingOrderCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceOrdersApi.updateCoolingOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpdateStrippingOrderCommand} [updateStrippingOrderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateStrippingOrder(updateStrippingOrderCommand?: UpdateStrippingOrderCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateStrippingOrder(updateStrippingOrderCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceOrdersApi.updateStrippingOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpdateStrippingOrderCargoItemActualAmountCommand} [updateStrippingOrderCargoItemActualAmountCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateStrippingOrderCargoItemActualAmount(updateStrippingOrderCargoItemActualAmountCommand?: UpdateStrippingOrderCargoItemActualAmountCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateStrippingOrderCargoItemActualAmount(updateStrippingOrderCargoItemActualAmountCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceOrdersApi.updateStrippingOrderCargoItemActualAmount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpdateStuffingOrderCommand} [updateStuffingOrderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateStuffingOrder(updateStuffingOrderCommand?: UpdateStuffingOrderCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateStuffingOrder(updateStuffingOrderCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceOrdersApi.updateStuffingOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ServiceOrdersApi - factory interface
 */
export const ServiceOrdersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ServiceOrdersApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateCoolingOrdersCommand} [createCoolingOrdersCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCoolingOrders(createCoolingOrdersCommand?: CreateCoolingOrdersCommand, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.createCoolingOrders(createCoolingOrdersCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCoolingOrder(id: number, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.deleteCoolingOrder(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteStrippingOrder(id: number, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.deleteStrippingOrder(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteStuffingOrder(id: number, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.deleteStuffingOrder(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} ids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByIds(ids: Array<number>, options?: RawAxiosRequestConfig): AxiosPromise<Array<StuffingOrderResponseDto>> {
            return localVarFp.getByIds(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} ids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCoolingOrdersByIds(ids: Array<number>, options?: RawAxiosRequestConfig): AxiosPromise<Array<CoolingOrderResponseDto>> {
            return localVarFp.getCoolingOrdersByIds(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} ids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStrippingOrdersByIds(ids: Array<number>, options?: RawAxiosRequestConfig): AxiosPromise<Array<StrippingOrderResponseDto>> {
            return localVarFp.getStrippingOrdersByIds(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateStrippingOrderCommand} [createStrippingOrderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        strippingOrder(createStrippingOrderCommand?: CreateStrippingOrderCommand, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.strippingOrder(createStrippingOrderCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateStuffingOrderCommand} [createStuffingOrderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stuffingOrder(createStuffingOrderCommand?: CreateStuffingOrderCommand, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.stuffingOrder(createStuffingOrderCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateCargoItemActualAmountCommand} [updateCargoItemActualAmountCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCargoItemActualAmount(updateCargoItemActualAmountCommand?: UpdateCargoItemActualAmountCommand, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateCargoItemActualAmount(updateCargoItemActualAmountCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateCoolingOrderCommand} [updateCoolingOrderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCoolingOrder(updateCoolingOrderCommand?: UpdateCoolingOrderCommand, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateCoolingOrder(updateCoolingOrderCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateStrippingOrderCommand} [updateStrippingOrderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStrippingOrder(updateStrippingOrderCommand?: UpdateStrippingOrderCommand, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateStrippingOrder(updateStrippingOrderCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateStrippingOrderCargoItemActualAmountCommand} [updateStrippingOrderCargoItemActualAmountCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStrippingOrderCargoItemActualAmount(updateStrippingOrderCargoItemActualAmountCommand?: UpdateStrippingOrderCargoItemActualAmountCommand, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateStrippingOrderCargoItemActualAmount(updateStrippingOrderCargoItemActualAmountCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateStuffingOrderCommand} [updateStuffingOrderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStuffingOrder(updateStuffingOrderCommand?: UpdateStuffingOrderCommand, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateStuffingOrder(updateStuffingOrderCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ServiceOrdersApi - object-oriented interface
 */
export class ServiceOrdersApi extends BaseAPI {
    /**
     * 
     * @param {CreateCoolingOrdersCommand} [createCoolingOrdersCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createCoolingOrders(createCoolingOrdersCommand?: CreateCoolingOrdersCommand, options?: RawAxiosRequestConfig) {
        return ServiceOrdersApiFp(this.configuration).createCoolingOrders(createCoolingOrdersCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteCoolingOrder(id: number, options?: RawAxiosRequestConfig) {
        return ServiceOrdersApiFp(this.configuration).deleteCoolingOrder(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteStrippingOrder(id: number, options?: RawAxiosRequestConfig) {
        return ServiceOrdersApiFp(this.configuration).deleteStrippingOrder(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteStuffingOrder(id: number, options?: RawAxiosRequestConfig) {
        return ServiceOrdersApiFp(this.configuration).deleteStuffingOrder(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<number>} ids 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getByIds(ids: Array<number>, options?: RawAxiosRequestConfig) {
        return ServiceOrdersApiFp(this.configuration).getByIds(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<number>} ids 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCoolingOrdersByIds(ids: Array<number>, options?: RawAxiosRequestConfig) {
        return ServiceOrdersApiFp(this.configuration).getCoolingOrdersByIds(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<number>} ids 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getStrippingOrdersByIds(ids: Array<number>, options?: RawAxiosRequestConfig) {
        return ServiceOrdersApiFp(this.configuration).getStrippingOrdersByIds(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateStrippingOrderCommand} [createStrippingOrderCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public strippingOrder(createStrippingOrderCommand?: CreateStrippingOrderCommand, options?: RawAxiosRequestConfig) {
        return ServiceOrdersApiFp(this.configuration).strippingOrder(createStrippingOrderCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateStuffingOrderCommand} [createStuffingOrderCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public stuffingOrder(createStuffingOrderCommand?: CreateStuffingOrderCommand, options?: RawAxiosRequestConfig) {
        return ServiceOrdersApiFp(this.configuration).stuffingOrder(createStuffingOrderCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateCargoItemActualAmountCommand} [updateCargoItemActualAmountCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateCargoItemActualAmount(updateCargoItemActualAmountCommand?: UpdateCargoItemActualAmountCommand, options?: RawAxiosRequestConfig) {
        return ServiceOrdersApiFp(this.configuration).updateCargoItemActualAmount(updateCargoItemActualAmountCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateCoolingOrderCommand} [updateCoolingOrderCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateCoolingOrder(updateCoolingOrderCommand?: UpdateCoolingOrderCommand, options?: RawAxiosRequestConfig) {
        return ServiceOrdersApiFp(this.configuration).updateCoolingOrder(updateCoolingOrderCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateStrippingOrderCommand} [updateStrippingOrderCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateStrippingOrder(updateStrippingOrderCommand?: UpdateStrippingOrderCommand, options?: RawAxiosRequestConfig) {
        return ServiceOrdersApiFp(this.configuration).updateStrippingOrder(updateStrippingOrderCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateStrippingOrderCargoItemActualAmountCommand} [updateStrippingOrderCargoItemActualAmountCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateStrippingOrderCargoItemActualAmount(updateStrippingOrderCargoItemActualAmountCommand?: UpdateStrippingOrderCargoItemActualAmountCommand, options?: RawAxiosRequestConfig) {
        return ServiceOrdersApiFp(this.configuration).updateStrippingOrderCargoItemActualAmount(updateStrippingOrderCargoItemActualAmountCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateStuffingOrderCommand} [updateStuffingOrderCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateStuffingOrder(updateStuffingOrderCommand?: UpdateStuffingOrderCommand, options?: RawAxiosRequestConfig) {
        return ServiceOrdersApiFp(this.configuration).updateStuffingOrder(updateStuffingOrderCommand, options).then((request) => request(this.axios, this.basePath));
    }
}

